<div class='container'>
    <mat-card>
        <mat-card-title>OPERATIONAL SETTING</mat-card-title>
        <br />
        <mat-form-field class='subid' appearance="outline">
            <mat-label>SUB ID</mat-label>
            <input matInput placeholder="SUB ID">
            <button mat-icon-button matSuffix>
                <mat-icon>done</mat-icon>
            </button>
        </mat-form-field>
        <br />

        <form>
            <div class='row'>
                <div class='col-md-6 col-12'>
                    <label for='very_low'>Very Low</label>
                    <mat-form-field appearance="standard">
                        <input matInput placeholder="" id='very_low'>
                    </mat-form-field>
                </div>

                <div class='col-md-6 col-12'>
                    <label for='low'>Low</label>
                    <mat-form-field appearance="standard">
                        <input matInput placeholder="" id='low'>
                    </mat-form-field>
                </div>

                <div class='col-md-6 col-12'>
                    <label for='high'>High</label>
                    <mat-form-field appearance="standard">
                        <input matInput placeholder="" id='high'>
                    </mat-form-field>
                </div>

                <div class='col-md-6 col-12'>
                    <label for='very_high'>Very High</label>
                    <mat-form-field appearance="standard">
                        <input matInput placeholder="" id='very_high'>
                    </mat-form-field>
                </div>
            </div>
            <br />
            <div class='submit'>
                <button mat-raised-button>Submit</button>
            </div>
        </form>
    </mat-card>
</div>